import { defineMessages } from 'react-intl';

const messages = defineMessages({
  vendors: {
    description: 'Fulfillment Providers page section subtitle',
    defaultMessage: 'Vendors',
    id: '6f8Pvj',
  },
  addAVendor: {
    description: 'Button to Add a Vendor',
    defaultMessage: 'Add a Vendor',
    id: '65JjKG',
  },
});

export default messages;
